import styled from "styled-components"

interface LandingStepperSegmentProps {
  selected: boolean
  isFirst: boolean
  isLast: boolean
}

export const LandingStepperSegment = styled.div<LandingStepperSegmentProps>`
  width: 152px;
  height: 7px;
  background: ${({theme, selected}) => (selected ? theme.colors.greys.white : "rgba(255, 255, 255, 0.5)")};
  border-radius: 0px;
  ${({isFirst}) =>
    isFirst &&
    `
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    `}
  ${({isLast}) =>
    isLast &&
    `
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    `}
`
